import { create, type StateCreator } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"
import type { Step } from "react-joyride"
import { productTourSteps } from "../constants/steps"

interface ProductTourState {
  currentStep: number
  steps: Step[]
  isActive: boolean
  isReady: boolean

  setCurrentStep: (currentStep: number) => void
  setSteps: (steps: Step[]) => void
  startTour: () => void
  closeTour: () => void
  setIsReady: (isReady: boolean) => void
}

const initialState = {
  currentStep: 0,
  steps: productTourSteps,
  isActive: false,
  isReady: false,
}

const state: StateCreator<ProductTourState> = (set) => ({
  ...initialState,
  setCurrentStep: (currentStep: number) => set({ currentStep }),
  setSteps: (steps: Step[]) => set({ steps }),
  startTour: () => set({ isActive: true }),
  closeTour: () => set({ isActive: false }),
  setIsReady: (isReady: boolean) => set({ isReady }),
})

export const useProductTour = create<ProductTourState>()(
  persist(state, {
    name: "@tuni/product-tour",
    storage: createJSONStorage(() => localStorage),
    partialize: (state) => ({
      currentStep: state.currentStep,
      isActive: state.isActive,
    }),
    onRehydrateStorage: () => (state) => {
      if (state) {
        // Mark the state as ready after rehydration
        state.setIsReady(true)
      }
    },
  }),
)
